import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import isSafari from 'lib/web/isSafari'
import isChrome from 'lib/web/isChrome'
import {
  GOOGLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

// Detect Android devices (all modern Android browsers support Google Pay)
const isAndroidDevice = typeof navigator !== 'undefined' &&
  navigator.userAgent.includes('Android')

/** Original narrow check — desktop Chrome only. */
export const isGooglePayEnabled = (currency: string): boolean => !!(config.GOOGLE_PAY_ENABLED && getPaymentMethods(currency).includes(GOOGLE_PAY_PAYMENT_TYPE) && !isSafari && isChrome)

/**
 * Broadened check — all Android browsers + desktop Chrome/Edge.
 * Modern Android browsers support Google Pay through the Payment Request API.
 * Used when the express checkout experiment is active so the broadened
 * availability can be rolled back by turning off the experiment.
 */
export const isGooglePayEnabledBroadened = (currency: string): boolean => !!(
  config.GOOGLE_PAY_ENABLED &&
  getPaymentMethods(currency).includes(GOOGLE_PAY_PAYMENT_TYPE) &&
  (isAndroidDevice || (isChrome && !isSafari))
)
